import AlertDismissible from '../../Shared/Components/AlertDismissible';
import Breadcrumbs from '../../Shared/Components/Breadcrumbs';
import Layout from '../../Shared/Layout/LayoutAdmin';
import React from 'react'
import Row from 'react-bootstrap/Row';
import { Link, usePage } from '@inertiajs/inertia-react';
import { hasPermission } from '../../utils/Permissions';

const List = ({ items }) => {
    const { flash } = usePage().props;
    const data = items.data;

    return (
        <Row>
            {flash.success && (
                <AlertDismissible message={flash.success} type="success" />
            )}
            <span className="pb-7 pt-7">
                <Breadcrumbs currentPath="/admin/master_data/taxregimes" />
            </span>
            <div className="card card-flush h-md-100">
                <div className="card-header pt-7">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bold text-gray-800">Listado de Regímenes Fiscales</span>
                    </h3>

                    <div className="card-toolbar">
                        {hasPermission('master_data.tax_regime.create') && (
                            <Link href={route('taxregimes.add')} className='me-3 btn btn-sm btn-primary'>Agregar Régimen Fiscal</Link>
                        )}
                    </div>
                </div>

                <div className="card-body pt-6">
                    <div className="table-responsive">
                        <table className="table table-row-dashed align-middle gs-0 gy-3 my-0">

                            <thead>
                                <tr className="fs-7 fw-bold text-gray-400 border-bottom-0">
                                    <th className="p-0 pb-3 min-w-175px text-start">Código</th>
                                    <th className="p-0 pb-3 min-w-175px text-start">Nombre</th>
                                    <th className="p-0 pb-3 min-w-175px text-start">Total de impuestos</th>
                                    <th className="p-0 pb-3 min-w-175px text-start">Activo</th>
                                    <th className="p-0 pb-3 w-50px text-end"></th>
                                </tr>
                            </thead>

                            <tbody>
                                {data.length === 0 && (
                                    <tr>
                                        <td
                                            className="px-6 py-3 text-center text-gray-800 fw-bold mb-1 fs-6"
                                            colSpan="5"
                                        >
                                            No hay datos.
                                        </td>
                                    </tr>
                                )}
                                {data.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <div className="d-flex justify-content-start flex-column">
                                                        <p className="text-gray-800 fw-bold mb-1 fs-6">{item.code}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <div className="d-flex justify-content-start flex-column">
                                                        <p className="text-gray-800 fw-bold mb-1 fs-6">{item.name}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <div className="d-flex justify-content-start flex-column">
                                                        <p className={`text-gray-800 mb-1 fs-6 ${item.taxes_count > 0 ? 'fw-bold' : ''}`}>
                                                            {item.taxes_count > 0 ? (
                                                                item.taxes_count
                                                            ) : (
                                                                <span className="text-gray-400">Sin impuestos</span>
                                                            )}
                                                        </p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <div className="d-flex justify-content-start flex-column">
                                                        <p className="text-gray-800 fw-bold mb-1 fs-6">
                                                            {item.active ? 'Sí' : 'No'}
                                                        </p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="d-flex justify-content-around">
                                                    <div className='mx-2'>
                                                        <Link href={route("taxregimes.edit", item.id)}>Editar</Link>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Row>
    );
}

List.layout = page => <Layout children={page} title="Regímenes Fiscales" />

export default List;
